import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { normalizePublicUrl, robotsFor, STATIC_PAGES, businessSchema } from '../seo/policy';

const SITE_URL = "https://www.kccparts.ca";

const Meta = ({ title = 'KCC Parts Distribution', description = 'Browse automotive parts from KCC Parts in Ottawa, Canada.', keywords = 'auto parts', canonicalPath, noindex = false, jsonLd }) => {
  const location = useLocation();
  const resolvedPath = normalizePublicUrl(canonicalPath || `${location.pathname}${location.search}`);
  const routeRobots = robotsFor(`${location.pathname}${location.search}`);
  const robots = routeRobots !== 'index,follow' ? routeRobots : noindex ? 'noindex,follow' : routeRobots;
  const staticPage = STATIC_PAGES[location.pathname];
  const page = Number(new URLSearchParams(location.search).get('page') || 1);
  const canonicalUrl = `${SITE_URL}${resolvedPath.startsWith("/") ? resolvedPath : `/${resolvedPath}`}`;
  const schema = jsonLd || (location.pathname === '/' ? businessSchema : staticPage ? { '@context': 'https://schema.org', '@type': 'WebPage', name: staticPage.h1, url: canonicalUrl } : null);

  return (
    <Helmet defer={false}>
      <title>{`${staticPage?.title || title}${page > 1 ? ` — Page ${page}` : ''}`}</title>
      <meta name="description" content={staticPage?.description || description} />
      <meta name="keywords" content={keywords} />
      <meta name="robots" content={robots} />
      {robots !== 'noindex,nofollow' && <link rel="canonical" href={canonicalUrl} />}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema).replace(/</g, '\\u003c')}
        </script>
      )}
    </Helmet>
  );
};

export default Meta;
